module.exports = __webpack_public_path__ + "static/media/about1.9cf295db.png";